import React, { useEffect, useState } from 'react'
import HTMLContent from '../HTMLContent'
import "./TabNavigation.scss"

const TabNavigation = (props) => {

    const { data, selected, onSelectHandle } = props
    const [ selectedIndex, setSelectedIndex ] = useState()
    const [ tabItems, setTabItems ] = useState()

    useEffect(() => {

        setSelectedIndex(selected)
        if(!tabItems) setTabItems(data)                                                  
        
    }, [selected]) 


    const handleSelect = (selection, index) => {

        const selected = { ...selection, viewed: true }

        const refreshItems = tabItems.map(item =>
            item.name === selected.name
                ? { ...item, viewed: true }
                : item
            );

        onSelectHandle(selected, index)
        setSelectedIndex(index)
        setTabItems(refreshItems)

    }
    return (

         <ul className="tabs-navigation" >
            {
                tabItems && tabItems.map((pattern, index) => {

                    const selected = selectedIndex === index
                    return (
                        <li 
                            key={index} 
                            className={`tabs-navigation-item ${selected ? 'selected' : ''}`} 
                            onClick={()=>handleSelect(pattern, index)}
                        >
                            <HTMLContent numberOfLines = {2} className="tabs-navigation-item-text" html={pattern.name} />
                        </li>
                    )
                }
            )}
        </ul>
    )
}

export default TabNavigation